module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal custom-modal fade",
    attrs: {
      "id": _vm.rel + '-delete-modal',
      "role": "dialog",
      "aria-labelledby": "delete-modal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title")], 2)]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "delete-modal-form",
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.deleteResource($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 margin-top-bottom"
  }, [_vm._t("message")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-fill",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-fill",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("No")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-035bd9d6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/DeleteModal.vue
// module id = 207
// module chunks = 14